module.exports = __webpack_public_path__ + "img/quicklink-tiles-lincoln.a6cfff82.png";